<template>
  <div
    v-observe-visibility="observeVisiblity()"
    :class="stockManagedClass"
    class="product-item"
  >
    <template v-if="isVisible">
      <CarouselProductImage :item="item" />
      <CarouselProductContent :item="item" />
    </template>
  </div>
</template>

<script>
import carouselProductMixin from '../../mixins/carouselProductMixin'
import CarouselProductImage from '../../components/list/carouselProductImage.vue'
import CarouselProductContent from '../../components/list/carouselProductContent.vue'

export default {
  name: 'list-product-0002',
  components: {
    CarouselProductImage,
    CarouselProductContent
  },
  mixins: [carouselProductMixin]
}
</script>

<style lang="scss" scoped>
@import "../../styles/product-list-card-styles.scss";
</style>
